import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8" data-testid="privacy-heading">Privacy Policy</h1>
          <Card>
            <CardContent className="p-8 prose prose-gray max-w-none">
              <p className="text-sm text-gray-500 mb-6">Last Updated: January 2025</p>
              
              <h2>1. Information We Collect</h2>
              <p>We collect the following types of information:</p>
              <ul>
                <li><strong>Account Information:</strong> Name, email address, phone number (optional)</li>
                <li><strong>Usage Data:</strong> Pages visited, deals viewed, searches performed</li>
                <li><strong>Device Information:</strong> Browser type, IP address, operating system</li>
                <li><strong>Location Data:</strong> Approximate location based on IP or GPS (if permitted)</li>
                <li><strong>Cookies:</strong> We use cookies to improve user experience</li>
              </ul>

              <h2>2. How We Use Your Information</h2>
              <p>We use collected information to:</p>
              <ul>
                <li>Provide and improve our services</li>
                <li>Personalize deal recommendations</li>
                <li>Send email notifications about deals (if opted in)</li>
                <li>Analyze usage patterns and improve user experience</li>
                <li>Communicate with you about your account</li>
                <li>Prevent fraud and ensure security</li>
              </ul>

              <h2>3. Information Sharing</h2>
              <p>We do NOT sell your personal information. We may share data with:</p>
              <ul>
                <li><strong>Merchants:</strong> When you click on a deal (for tracking purposes only)</li>
                <li><strong>Service Providers:</strong> Email services, analytics tools, hosting providers</li>
                <li><strong>Legal Requirements:</strong> If required by law or to protect our rights</li>
              </ul>

              <h2>4. Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies to remember your preferences, analyze site traffic, and provide personalized content. You can control cookies through your browser settings.
              </p>

              <h2>5. Third-Party Links</h2>
              <p>
                Our Service contains links to merchant websites. We are not responsible for their privacy practices. Please review their policies before providing information.
              </p>

              <h2>6. Data Security</h2>
              <p>
                We implement reasonable security measures to protect your information. However, no internet transmission is 100% secure. You use our Service at your own risk.
              </p>

              <h2>7. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal data</li>
                <li>Correct inaccurate information</li>
                <li>Delete your account and data</li>
                <li>Opt-out of marketing emails</li>
                <li>Export your data</li>
              </ul>

              <h2>8. Children's Privacy</h2>
              <p>
                Our Service is not intended for users under 18. We do not knowingly collect information from children.
              </p>

              <h2>9. International Users</h2>
              <p>
                Our Service is based in the UAE. By using it, you consent to data transfer and processing in the UAE.
              </p>

              <h2>10. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy periodically. Changes will be posted on this page with an updated date.
              </p>

              <h2>11. Contact Us</h2>
              <p>
                For privacy concerns or data requests, contact: <a href="mailto:privacy@yallasavings.com" className="text-emerald-600">privacy@yallasavings.com</a>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};